import React from 'react';

const HostContext = React.createContext();

const HostProvider = (props) => {
  return (
    <HostContext.Provider value={props.value}>
      {props.children}
    </HostContext.Provider>
  );
};

export { HostContext, HostProvider}
